import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { IGeofence } from "@app/interfaces/IGeofences";
import { GeofenceService } from "@app/services/geofence.service";
import { TranslationService } from "@app/services/translation.service";
import "./v-geofence-autocomplete.component.scss";

@Component({
    selector: "v-geofence-autocomplete",
    template: require('./v-geofence-autocomplete.component.html')
})
export class VGeofenceAutocompleteComponent implements OnChanges {
    @Input() geofence: IGeofence;
    @Input() selectedGeofenceId: string;

    @Output() geofenceSelected: EventEmitter<IGeofence> = new EventEmitter();
    @Output() clear = new EventEmitter<void>();

    @Input() label: string = this.translationService.t("Common.Geofence");
    @Input() placeholder: string = this.translationService.t("Common.SelectGeofence");

    // ---

    geofencePromise: angular.IPromise<IGeofence[]>;

    constructor(
        private readonly geofenceService: GeofenceService,
        private readonly translationService: TranslationService
    ) {
    }

    ngOnChanges() {

        if (this.selectedGeofenceId) {
            this.loadData();
        }
    }

    onCleared(): void {
        this.clear.emit();
    }

    onFocus() {
        this.loadData();
    }

    onGeofenceClicked(geofence: IGeofence) {
        this.geofenceSelected.emit(geofence);
    }

    geofenceFilter = (geofence: IGeofence, text: string): boolean => {
        return geofence.Description.toLowerCase().indexOf(text) >= 0;
    }

    // ---

    private loadData() {
        this.geofencePromise = this.geofenceService.getGeofences();
    }
}
